import { render, staticRenderFns } from "./ColorSelectFiltro.vue?vue&type=template&id=5215a358&"
import script from "./ColorSelectFiltro.vue?vue&type=script&lang=js&"
export * from "./ColorSelectFiltro.vue?vue&type=script&lang=js&"
import style0 from "./ColorSelectFiltro.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports